import React from "react";
import AddProvinciaForm from "./AddProvinciaForm";

const AddProvincia = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="col-12">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Nueva Provincia"}
        </button>
      </div>
      {show && (
        <div className="col-md-8 offset-md-2 mb-3">
          <AddProvinciaForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddProvincia;
